import {
  DataConfig,
  SortableConfig,
} from '@aibees/elephant/components/sortable-table';
import {
  SortableAction,
  SortableActionProps,
} from '@aibees/elephant/components/sortable-table/components/sortable-action';
import { SortableActive } from '@aibees/elephant/components/sortable-table/components/sortable-active';
import { DateTime, TextEllipsis } from '@aibees/shared/components';
import { ParsedPreset, UserRelation } from '@aibees/shared/definition';
import { userGetFullName } from '@aibees/shared/utils';
import { useBuyingTeamDialogsContext } from '../../context';
import { useUpdateStatusBuyingTeamApi } from '../../hooks/use-update-status-buying-team-api';

export const columns: SortableConfig<ParsedPreset<DataConfig>>[] = [
  {
    key: 'name',
    label: 'Name',
    render: (v) => <TextEllipsis value={v.name} />,
    sx: { width: '25%' },
  },
  {
    key: 'createdBy',
    label: 'Created By',
    render: (v) => (
      <TextEllipsis
        value={
          v.value.default
            ? 'System'
            : userGetFullName({
                firstName: v.user.firstName,
                lastName: v.user.lastName,
              } as UserRelation)
        }
      />
    ),
    sx: { width: '25%' },
  },
  {
    key: 'modified',
    label: 'Last Modified',
    render: (v) => {
      if (v.user.id === 'system') {
        // TODO: this condition is based on fake data and should be reconsidered after taking care of sample teams
        return '';
      }
      return <DateTime value={v.modified} format="dd LLLL, yyyy" />;
    },
    sx: { width: '25%' },
  },
  {
    key: 'active',
    label: 'Active',
    render: (v) => <RenderSortableActive item={v} />,
    sx: { width: '15%', justifyContent: 'center' },
  },
  {
    key: 'value',
    label: 'Action',
    render: (v, create, open) => (
      <RenderSortableAction
        item={v}
        createDialogState={create}
        openingDialogState={open}
        presetTitle="Buying Team"
      />
    ),
    sx: { width: '10%' },
    headerCellSx: { textAlign: 'center' },
  },
];

const RenderSortableActive = ({ item }: { item: ParsedPreset<DataConfig> }) => {
  const { updateBuyingTeamStatus, isLoading } =
    useUpdateStatusBuyingTeamApi(item);
  if (item.user.id === 'system') {
    // TODO: this condition is based on fake data and should be reconsidered after taking care of sample teams
    return '';
  }
  return (
    <SortableActive
      item={item}
      handleToggleActive={updateBuyingTeamStatus}
      isLoading={isLoading}
    />
  );
};

const RenderSortableAction = ({
  item,
  createDialogState,
  openingDialogState,
  presetTitle,
}: Omit<SortableActionProps, 'beforeEditAction' | 'beforeDuplicateAction'>) => {
  const { setName, editMode, setSelectedItem } = useBuyingTeamDialogsContext();

  const handleBeforeEdit = () => {
    editMode?.onTrue();
    setName(item.name);
    setSelectedItem(item);
  };

  const handleBeforeDuplicate = () => {
    setName(`Copy of ${item.name}`);
  };

  return (
    <SortableAction
      item={item}
      createDialogState={createDialogState}
      openingDialogState={openingDialogState}
      presetTitle={presetTitle}
      beforeEditAction={handleBeforeEdit}
      beforeDuplicateAction={handleBeforeDuplicate}
    />
  );
};
